import { create } from "zustand";

export const useStoreCRMCreate = create((set, get) => ({
  crmBulkCreatePayload: [],
  crmBulkCreateData: [],
  isCRMBulkCreateLoading: true,
  isCRMBulkCreateFetched: false,

  // Set payload
  setCRMBulkCreatePayload: (data) => {
    set({
      crmBulkCreatePayload: data,
      isCRMBulkCreateLoading: data.length > 0,
      isCRMBulkCreateFetched: false,
      // crmBulkCreateData: [], // optional: reset data on new payload
    });
  },

  // Set entire data manually
  setCRMBulkCreateData: (data) => {
    set({
      crmBulkCreateData: data,
      isCRMBulkCreateLoading: data.length < get().crmBulkCreatePayload.length,
      isCRMBulkCreateFetched: data.length === get().crmBulkCreatePayload.length,
    });
  },

  // Add or update a chunk

  addChunkInCRMBulkCreateData: (chunk) => {
    const state = get();
    const existing = [...state.crmBulkCreateData];

    // Determine the ID key and value
    let idKey = "recordId";
    if (chunk.person_id) {
      idKey = "person_id";
    }
    if (chunk.contact_id) {
      idKey = "contact_id";
    }
    if (chunk.organization_id) {
      idKey = "organization_id";
    }

    const idValue = chunk[idKey];

    console.log("chunk", chunk);

    // Find the index using any of the 3 ID types
    const index = existing.findIndex(
      (r) =>
        r.person_id === idValue ||
        r.contact_id === idValue ||
        r.recordId === idValue ||
        r.organization_id === idValue
    );

    const newEntry = {
      [idKey]: idValue,
      records: [...chunk.data],
      crm_response_info: chunk?.crm_response_info,
      record_url: chunk?.record_url,
    };

    if (index !== -1) {
      existing[index] = {
        ...existing[index],
        ...newEntry,
      };
    } else {
      existing.push(newEntry);
    }

    const isLoading = existing.length < state.crmBulkCreatePayload.length;
    const isFetched = existing.length === state.crmBulkCreatePayload.length;

    set({
      crmBulkCreateData: existing,
      isCRMBulkCreateLoading: isLoading,
      isCRMBulkCreateFetched: isFetched,
    });
  },

  // ✅ Get specific record by ID
  getCRMCreateRecordById: (id) => {
    const state = get();
    return state.crmBulkCreateData.find(
      (item) =>
        item.person_id === id || item.contact_id === id || item.recordId === id || item.organization_id === id
    );
  },
  getCRMCreateRecordByIdFlat: (id) => {
    const state = get();
    const matched = state.crmBulkCreateData.find(
      (item) =>
        item.person_id === id || item.contact_id === id || item.recordId === id || item.organization_id === id
    );

    if (!matched || !Array.isArray(matched.records)) return [];

    // Extract and flatten all non-null inner `records` arrays
    return matched.records
      .map((entry) => entry?.records || []) // get inner records array
      .flat(); // flatten into a single array
  },
}));
